import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../../theme';
import cn from 'classnames';
const Fare = ({ fare, isFullFareConditions, contentTableRef, selectedFare, fareIndex }) => {
    const { t } = useTranslation('CompareFares');
    const { Fare: css } = useTheme('CompareFares');
    const selectedFareRef = React.useRef();
    const getSelectedFareParameters = () => {
        var _a;
        const contentTableHeight = (_a = contentTableRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight;
        const slickList = document.querySelector('.slick-list');
        if (contentTableHeight && selectedFareRef.current && slickList.clientHeight) {
            slickList.style.paddingBottom = `${contentTableHeight}px`;
            slickList.style.marginBottom = `-${contentTableHeight}px`;
            selectedFareRef.current.style.height = `${contentTableHeight}px`;
        }
    };
    React.useEffect(() => {
        getSelectedFareParameters();
    }, [isFullFareConditions]);
    return (React.createElement("div", { className: css.headingWrp },
        fare.title === selectedFare && React.createElement("div", { className: css.selectedFare, ref: selectedFareRef }),
        React.createElement("div", { "data-fareIndex": fareIndex + 1, className: cn(css.fareHeadingItem, {
                [css.fareHeadingItem_isKey]: fare.serviceClass === 'Business',
                [css.fareHeadingItem_isFirstClass]: fare.serviceClass === 'First'
            }) },
            React.createElement("span", { className: css.fareHeadingItem__title }, fare.title ? ` ${fare.title}` : '')),
        !isFullFareConditions && (fare === null || fare === void 0 ? void 0 : fare.image) && (React.createElement("img", { className: css.image, src: fare.image, alt: t(fare.title), onLoad: getSelectedFareParameters }))));
};
export default Fare;
